import React, { Component } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, Tooltip, Grid, Box } from '@mui/material';
import siteAvailability from '../assets/siteAvaibility.png';
import '../CSS/SiteAvailability.css';
import View from './View';
import { isBefore } from 'date-fns';
import { CircularProgress } from '@material-ui/core';
import { getSiteAvailabilityData, getSiteRigDiscountExtra, getReservation, getBlackoutDates } from '../utils/OpenCampground_Database_Calls'
import { format } from 'date-fns';

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});

const statuses = [
    { color: "#98B2A5", label: "Occupied" },
    { color: "#8BD9CC", label: "Reserved" },
    { color: "#f5f19a", label: "Not Checked In" },
    { color: "#86888F", label: "Unavailable" },
    { color: "#f28080", label: "Overstay" },
];

class SiteAvailability extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spaces: [],
            reservations: [],
            dates: [],
            sites: [],
            todaysDate: format(new Date(), 'yyyy-MM-dd'),
            allSpaces: [],
            availableSitesToday: '',
            loading: true,
            view: false,
            viewItem: {}
        };
    }

    async componentDidMount() {
        let siteRigDiscountExtra = await getSiteRigDiscountExtra(this.props.user, this.props.serverName);
        let startDate = new Date();
        startDate.setDate(startDate.getDate() - 2);
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const formattedTomorrow = format(tomorrow, 'yyyy-MM-dd');
        let getSiteAvailabilityDataResponse = await getSiteAvailabilityData(this.props.user, this.props.serverName, startDate.toISOString().split('T')[0], this.state.todaysDate, formattedTomorrow)
        const dates = [];
        let endDate = new Date();
        endDate.setFullYear(startDate.getFullYear() + 1);
        for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
            let formattedDate = d.toISOString().split('T')[0];
            dates.push(formattedDate);
        }
        this.setState({
            spaces: getSiteAvailabilityDataResponse.body[1],
            allSpaces: getSiteAvailabilityDataResponse.body[1],
            reservations: getSiteAvailabilityDataResponse.body[0],
            dates: dates,
            sites: siteRigDiscountExtra[0],
            availableSitesToday: getSiteAvailabilityDataResponse.body[2][0].available_spaces_count,
            loading: false
        });
    }

    // isReserved(space, date) {
    //     const today = new Date();
    //     today.setDate(today.getDate() - 3);
    //     const currentDate = new Date(date).toISOString().split('T')[0];
    //     for (let res of this.state.reservations) {
    //         if (
    //             res.space === space &&
    //             new Date(date) >= new Date(res.startdate) &&
    //             new Date(date) <= new Date(res.enddate)
    //         ) {
    //             const isFirstDay = currentDate === res.startdate.split('T')[0];
    //             const isLastDay = currentDate === res.enddate.split('T')[0];
    //             let startedReservation = currentDate === today.toISOString().split('T')[0] && new Date(res.startdate).toISOString().split('T')[0] < today.toISOString().split('T')[0];
    //             return { camper: res.camper, isFirstDay, isLastDay, startedReservation, id: res.id, startdate: res.startdate, enddate: res.enddate, checked_in: res.checked_in, checked_out: res.checked_out };
    //         }
    //     }
    //     return null;
    // }

    isReserved(space, date) {
        const today = new Date();
        today.setDate(today.getDate() - 3);
        const currentDate = new Date(date).toISOString().split('T')[0];
    
        for (let res of this.state.reservations) {
            const start = new Date(res.startdate);
            const end = new Date(res.enddate);
            end.setDate(end.getDate() - 1); // ✅ make end exclusive
    
            if (
                res.space === space &&
                new Date(date) >= start &&
                new Date(date) <= end
            ) {
                const isFirstDay = currentDate === res.startdate.split('T')[0];
                const isLastDay = currentDate === res.enddate.split('T')[0];
                const startedReservation = currentDate === today.toISOString().split('T')[0] &&
                    new Date(res.startdate).toISOString().split('T')[0] < today.toISOString().split('T')[0];
    
                return {
                    camper: res.camper,
                    isFirstDay,
                    isLastDay,
                    startedReservation,
                    id: res.id,
                    startdate: res.startdate,
                    enddate: res.enddate,
                    checked_in: res.checked_in,
                    checked_out: res.checked_out
                };
            }
        }
    
        return null;
    }

    filterChange = async (selectedSite) => {
        let filteredSpaces;
        this.setState({
            loading: true
        })
        if (selectedSite === 'ALL') {
            filteredSpaces = this.state.allSpaces
        } else {
            filteredSpaces = await this.state.allSpaces.filter(space => space.siteType === selectedSite)
        }
        this.setState({
            spaces: filteredSpaces,
            loading: false
        })
    }

    handleClick = async (id) => {
        let response = await getReservation(this.props.user, this.props.serverName, id);
        console.log(JSON.stringify(response));
        this.setState({
            viewItem: response[0],
            view: true,
        })
    }

    goBack = () => {
        this.setState({
            view: false,
            viewItem: {}
        });
    }

    render() {
        const { spaces, dates } = this.state;
        {
            return this.state.view ? <Grid className='reservationList'><View serverName={this.props.serverName} viewItem={this.state.viewItem} goBack={this.goBack} user={this.props.user} /></Grid>
                :
                <ThemeProvider theme={theme}>
                    <Grid className='siteAvailability'>
                        <Box className='infoBox'>
                            <Typography className='infoBarTypo'>Welcome: {this.props.serverName.charAt(0).toUpperCase() + this.props.serverName.slice(1)}</Typography>
                            <Typography className='infoBarTypo'>Username: {this.props.user}</Typography>
                        </Box>

                        <div className='box' style={{ alignItems: 'flex-start' }}>
                            <div className='divStyle'>
                                <img src={siteAvailability} alt="siteAvailability" className='buttonImage' />
                                <Typography className='siteAvailabilitytypography'>
                                    Site Availability
                                </Typography>
                            </div>
                        </div>
                        <div className="status-container">
                            {statuses.map((status, index) => (
                                <div key={index} className="status-item">
                                    <div className="color-circle" style={{ backgroundColor: status.color }}></div>
                                    <span>{status.label}</span>
                                </div>
                            ))}
                        </div>

                        <Box className='tableContainer'>
                            <div style={{ border: '1px solid #979797', margin: "40px 20px 27px", padding: "0 0 0 40px", borderRadius: "1000px", display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', left: '20px' }}>
                                <p style={{ fontSize: '18px', fontWeight: "700", margin: "0px" }}>Available Sites: {this.state.availableSitesToday}</p>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                        <select onChange={(e) => this.filterChange(e.target.value)}>
                                            <option value="ALL">All</option>
                                            {this.state.sites.map((site, index) => (
                                                <option key={index} value={site.name}>
                                                    {site.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {this.state.loading ? <CircularProgress style={{ position: 'relative', top: '30%' }} /> :
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className="stickyFirstColumn">Site Number</TableCell>
                                            {dates.map((date, idx) => (
                                                <TableCell key={idx} className="stickyHeader">
                                                    {date.split('-')[1]}/{date.split('-')[2]}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {spaces.map((spaceObj, idx) => {
                                            const space = spaceObj.name;
                                            let isactive = spaceObj.active;
                                            console.log(isactive + "value of isactive");
                                            const reservationsMap = new Map();
                                            // dates.forEach((date) => {
                                            //     const reservation = this.isReserved(space, date);
                                            //     if (reservation) {
                                            //         reservationsMap.set(date, reservation);
                                            //     }
                                            // });
                                            // dates.forEach((date) => {
                                            //     const reservation = this.isReserved(space, date);
                                            //     if (reservation) {
                                            //         // const current = new Date(date);
                                            //         // const end = new Date(reservation.enddate);
                                            //         // end.setDate(end.getDate() - 1); // Adjust to one day before enddate
                                            
                                            //         // if (current <= end) {
                                            //         //     reservationsMap.set(date, reservation);
                                            //         // }
                                            //         const current = new Date(date);
                                            //         const start = new Date(reservation.startdate);
                                            //         const end = new Date(reservation.enddate);

                                            //         // Only render dates from startdate to enddate - 1
                                            //         if (current >= start && current < end) {
                                            //             reservationsMap.set(date, reservation);
                                            //         }
                                            //     }
                                            // });
                                            dates.forEach((date) => {
                                                const reservation = this.isReserved(space, date);
                                                if (reservation) {
                                                    const current = new Date(date);
                                                    const start = new Date(reservation.startdate);
                                                    const end = new Date(reservation.enddate);
                                                    end.setDate(end.getDate() - 1); // ⬅️ Make end date exclusive
                                            
                                                    if (current >= start && current <= end) {
                                                        reservationsMap.set(date, reservation);
                                                    }
                                                }
                                            });
                                            let mergedReservations = [];
                                            let i = 0;
                                            // while (i < dates.length) {
                                            //     const date = dates[i];
                                            //     const reservation = reservationsMap.get(date);
                                            //     if (reservation) {
                                            //         let colSpan = 1;
                                            //         const endDate = new Date(reservation.enddate);
                                            //         endDate.setDate(endDate.getDate() - 1);
                                            //         while (i + colSpan < dates.length) {
                                            //             const nextDate = new Date(dates[i + colSpan]);
                                            //             if (nextDate <= endDate && reservationsMap.get(dates[i + colSpan])?.id === reservation.id) {
                                            //                 colSpan++;
                                            //             } else {
                                            //                 break;
                                            //             }
                                            //         }
                                            //         mergedReservations.push({ type: "reservation", data: reservation, colSpan });
                                            //         i += colSpan;
                                            //         // while (reservationsMap.get(dates[i + colSpan])?.id === reservation.id) {
                                            //         //     colSpan++;
                                            //         // }
                                            //         // mergedReservations.push({ type: "reservation", data: reservation, colSpan });
                                            //         // i += colSpan;
                                            //     }
                                            //     else {
                                            //         mergedReservations.push(null);
                                            //         i++;
                                            //     }
                                            // }
                                            while (i < dates.length) {
                                                const date = dates[i];
                                                const reservation = reservationsMap.get(date);
                                                if (reservation) {
                                                    let colSpan = 1;
                                                    while (
                                                        i + colSpan < dates.length &&
                                                        reservationsMap.get(dates[i + colSpan])?.id === reservation.id
                                                    ) {
                                                        colSpan++;
                                                    }
                                                    mergedReservations.push({ type: "reservation", data: reservation, colSpan });
                                                    i += colSpan;
                                                } else {
                                                    mergedReservations.push(null);
                                                    i++;
                                                }
                                            }
                                            return (
                                                <TableRow key={idx} style={{ backgroundColor: isactive == '1' ? 'white' : '#86888F' }}>
                                                    <TableCell className="stickyFirstColumn">{space}</TableCell>
                                                    {mergedReservations.map((entry, i) =>
                                                        entry ? (
                                                            <Tooltip title={entry.data.camper} arrow>
                                                                <TableCell key={i} className="dateCell"
                                                                    onClick={() => this.handleClick(entry.data.id)}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        cursor: "pointer",
                                                                        border: "0.5px solid white",
                                                                        backgroundColor: (() => {
                                                                            const startDate = entry?.data?.startdate ? new Date(entry?.data?.startdate) : null;
                                                                            const endDate = entry?.data?.enddate ? new Date(entry?.data?.enddate) : null;
                                                                            const today = new Date(this.state.todaysDate); // Convert today's date to a Date object
                                                                            if (!entry?.data?.checked_out && entry?.data?.checked_in && endDate && isBefore(endDate, today)) {
                                                                                return '#f28080'; // Checked-in but past end date
                                                                            }
                                                                            if (startDate && startDate > today) {
                                                                                return '#8BD9CC'; // Future reservation
                                                                            }
                                                                            if (entry?.data?.checked_in && endDate && endDate >= today) {
                                                                                return '#98B2A5'; // Active reservation
                                                                            }
                                                                            if (!entry?.data?.checked_in && startDate && startDate <= today) {
                                                                                return '#f5f19a'; // Should have checked in but hasn’t
                                                                            }
                                                                            return 'white'; // Default case
                                                                        })(),
                                                                    }}
                                                                    colSpan={entry.colSpan}
                                                                >
                                                                    {entry.data.camper+" "+entry.data.id}
                                                                </TableCell>
                                                            </Tooltip>
                                                        ) : (
                                                            <TableCell key={i} className="dateCell" style={{ backgroundColor: "transparent", textAlign: "center", border: "none" }} />
                                                        )
                                                    )}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            }
                        </Box>
                    </Grid>
                </ThemeProvider>
        }
    }
}
export default SiteAvailability;